// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@keller/XDL/types";
import { color, ellipsis } from "@keller/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        border: "rounded",
        sizeVariant: "default",
        backgroundColor: "common.white",
        labelProps: {
            mergeCss: true,
            size: 12,
            weight: "bold",
            transform: "capitalize",
            css: css`
                min-height: initial;
                letter-spacing: 0;
                line-height: 13px;
            `,
        },
        errorProps: {
            mergeCss: true,
            size: 12,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 13px;
            `,
        },
        cssOverrides: {
            descriptionWrapper: css`
                &&&& {
                    margin-top: 4px;
                }
            `,
            formInputWrapper: css`
                input,
                textarea,
                select {
                    &:not(.react-datetime-picker__inputGroup__input):not([name="datetime"]) {
                        ${ellipsis(1)}
                        text-overflow: ellipsis;
                        &::placeholder {
                            font-size: 14px;
                            font-style: italic;
                            letter-spacing: 0;
                            line-height: 16px;
                            max-width: 100%;
                        }
                    }
                }
            `,
            inputSelect: css`
                &:focus {
                    box-shadow: inset 0 1px 0 0 ${color("common.ui8", 0.1)};
                }
            `,
        },
    },
} as xBaseTheme["formField"];
